import { render, staticRenderFns } from "./DataLayer.vue?vue&type=template&id=70c6d827&scoped=true"
import script from "./DataLayer.vue?vue&type=script&lang=js"
export * from "./DataLayer.vue?vue&type=script&lang=js"
import style0 from "./DataLayer.vue?vue&type=style&index=0&id=70c6d827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c6d827",
  null
  
)

export default component.exports